export const MOG = {
  NORMAL: {
    '--standard-normal-pure-black-color': '#000000',
    '--standard-normal-pure-white-color': '#ffffff',
    '--standard-normal-primary-color': '#000',
    '--standard-normal-secondary-color': '#000012',
    '--standard-normal-primary-text-color': '#fff',
  },
  MINI: {
    '--standard-mini-pure-black-color': '#000000',
    '--standard-mini-pure-white-color': '#ffffff',
    '--standard-mini-primary-color': '#000',
    '--standard-mini-secondary-color': '#000012',
    '--standard-mini-primary-text-color': '#fff',
  },
}
